/**
 * The three boards the leaderboard serves.
 *
 * Each value is the URL hash that opens its board, so a board's address and the
 * board itself have one definition rather than two that can drift apart.
 */
export enum LeaderboardBoard {
  Households = "households",
  Adults = "adults",
  Minors = "minors",
}
